import React, { useEffect, useState, useRef } from "react";
import { FormGroup, Label } from "reactstrap";
import InputSelectCustom from "../Common/InputSelectCustom";
import InputSelectMultiCustom from "../Common/InputSelectMultiCustom";
import { replaceFlagByInputValue } from "../../helpers/functions";
import BizinBackend from "../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";

const processBackend = async (
  proc_name,
  proc_params,
  cookies,
  access_token_msman,
  payload = [],
) => {
  try {
    let data = payload;
    if (!payload || !payload.length) {
      data = await BizinBackend.executeProcedure(
        proc_params,
        proc_name,
        cookies,
        access_token_msman,
      );
    }

    if (data.length) {
      const options = data.map((item) => ({
        value: Object.values(item)[0],
        label: Object.values(item)[1],
      }));
      return options;
    }
  } catch (error) {
    return "Erro ao buscar dados [combobox] :" + error;
  }
};

const ComboBoxAutomatic = ({
  id,
  titulo,
  placeholder,
  isDisabled,
  initialValue = [],
  alienated = [],
  dataOptions = [],
  valueOptions = [],
  idAlienated,
  procName,
  procParams,
  isMulti = false,
  callbackSelected = () => {},
  callbackRemoveSelected = () => {},
  formGroupClassName = "",
}) => {
  const csrfToken = useGetCsrfToken();
  const [displayedOptions, setdisplayedOptions] = useState();
  const [value, setValue] = useState(initialValue);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.login.user);
  const [alienatedProps, setAlienatedProps] = useState();
  const initialValueRef = useRef(initialValue);
  const loadingRef = useRef(false);

  // Manter a ref atualizada
  useEffect(() => {
    initialValueRef.current = initialValue;
  }, [initialValue]);

  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = displayedOptions.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase()),
      );
      callback(filteredOptions);
    } else {
      callback(displayedOptions);
    }
  };

  const getData = async () => {
    if (!procName || !procParams || !csrfToken || !user?.access_token) return;
    if (loadingRef.current) return; // Evitar chamadas duplicadas
    loadingRef.current = true;
    setIsLoading(true);
    let params = procParams;

    if (alienated && alienated.length) {
      params = replaceFlagByInputValue(JSON.stringify(params), alienated);
    }

    const data = await processBackend(
      procName,
      Object.assign({}, params),
      csrfToken,
      user?.access_token,
      valueOptions,
    );

    setIsLoading(false);
    loadingRef.current = false;
    // Não zerar o value se já há um initialValue com value definido (usando ref para pegar valor mais recente)
    const currentInit = initialValueRef.current;
    if (
      !currentInit ||
      (typeof currentInit === "object" && !currentInit?.value)
    ) {
      setValue([]);
    }
    setdisplayedOptions(data);
  };

  // Carregar dados quando csrfToken e access_token estiverem disponíveis
  // No modo disabled (visualizar), pula o getData e usa só o initialValue como opção
  useEffect(() => {
    if (!idAlienated?.length && csrfToken && user?.access_token) {
      if (isDisabled && initialValue && initialValue?.value) {
        // Modo view: não precisa carregar todas as opções, só precisa do valor atual
        setdisplayedOptions([
          {
            value: initialValue.value,
            label: initialValue.label || initialValue.value,
          },
        ]);
      } else if (!isDisabled) {
        getData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [csrfToken, user?.access_token, isDisabled]);

  useEffect(() => {
    if (JSON.stringify(alienatedProps) === JSON.stringify(alienated)) return;
    setAlienatedProps(alienated);

    if (!alienated?.length) return;

    // Não remover o valor selecionado quando estiver desabilitado (modo view)
    // ou quando já há um initialValue definido (preservar valor selecionado)
    if (!isDisabled && !(initialValue && initialValue?.value)) {
      callbackRemoveSelected(id);
    }
    getData();
  }, [alienated]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (!!initialValue && initialValue?.value) {
      callbackSelected({ [id]: initialValue });
    }
  }, []);

  return (
    <FormGroup className={formGroupClassName}>
      {titulo && <Label>{titulo}</Label>}
      <div>
        {isMulti ? (
          <InputSelectMultiCustom
            id={id}
            name={titulo}
            stateSelected={initialValue[0]?.values || initialValue}
            optionsData={dataOptions.length ? dataOptions : displayedOptions}
            placeholder={placeholder}
            isLoading={isLoading}
            isDisabled={isLoading || isDisabled}
            loadOptions={loadOptions}
            handleOnChange={(selected) => {
              callbackSelected({ [id]: [{ values: selected, field: titulo }] });
              setValue(selected);
            }}
          />
        ) : (
          <InputSelectCustom
            id={id}
            name={titulo}
            stateSelected={value}
            optionsData={dataOptions.length ? dataOptions : displayedOptions}
            placeholder={placeholder}
            isLoading={isLoading}
            isDisabled={isLoading || isDisabled}
            loadOptions={loadOptions}
            handleOnChange={(selected) => {
              const payload = { ...selected, field: titulo, isSelect: true };
              callbackSelected({ [id]: payload });
              setValue(selected);
            }}
          />
        )}
      </div>
    </FormGroup>
  );
};

export default ComboBoxAutomatic;
